jQuery(document).ready(function () {
        jQuery('.loader').addClass('loaded');
        setTimeout(function () {
            jQuery('.loader').css({'height': '0px', 'width': '0px'});
        }, 320);
});

jQuery(document).ready(function () {

    setTimeout(function () {
        jQuery('.woocommerce-message').fadeOut();
        jQuery('.woocommerce-error').fadeOut();
    }, 5000);

    jQuery(document).on('DOMNodeInserted', function (e) {
        if (jQuery(e.target).is('.woocommerce-message')) {
            setTimeout(function () {
                jQuery('.woocommerce-message').fadeOut();
            }, 5000);
        }
        if (jQuery(e.target).is('.woocommerce-error')) {
            setTimeout(function () {
                jQuery('.woocommerce-error').fadeOut();
            }, 5000);
        }
    });

    jQuery('.menu-trigger').each(function () {
        var $this = jQuery(this);
        var beginTouch;
        var endTouch;

        jQuery(this).bind('touchstart click', function () {
            beginTouch = jQuery('body').scrollTop();
        }).bind('touchend click', function () {
            endTouch = jQuery('body').scrollTop();
            /* If the user has swiped, do not show the menu */
            if (endTouch === beginTouch) {
                if ($this.hasClass('active')) {
                    jQuery('.menu-container-mobile .menu').slideUp(400, function () {
                        $this.removeClass('active').addClass('inactive');
                    });
                }
                if ($this.hasClass('inactive')) {
                    jQuery('.menu-container-mobile .menu').slideDown(400, function () {
                        $this.removeClass('inactive').addClass('active');
                    });
                }
            }
        });
    });

    jQuery('.category-trigger').each(function () {
        var $this = jQuery(this);
        var beginTouch;
        var endTouch;

        jQuery(this).bind('touchstart click', function () {
            beginTouch = jQuery('body').scrollTop();
        }).bind('touchend click', function () {
            endTouch = jQuery('body').scrollTop();
            /* If the user has swiped, do not show the menu */
            if (endTouch === beginTouch) {
                if ($this.hasClass('active')) {
                    jQuery('.webshop-categories.mobile .category-breadcrumb').slideUp(400, function () {
                        $this.removeClass('active').addClass('inactive');
                    });
                }
                if ($this.hasClass('inactive')) {
                    jQuery('.webshop-categories.mobile .category-breadcrumb').slideDown(400, function () {
                        $this.removeClass('inactive').addClass('active');
                    });
                }
            }
        });
    });
});

jQuery(window).load(function () {
    setTimeout(function () {
        resizeProducts();
    }, 200);
});

function resizeProducts() {
    var maxheight = 0;
    if (jQuery('.products').length) {
        jQuery('.products li').each(function (i) {
            maxheight = (jQuery(this).outerHeight() > maxheight ? jQuery(this).outerHeight() : maxheight);
        });
        jQuery('.products li').css('height', maxheight + 'px');
    }
}